var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"button is-primary changePlataform",on:{"click":_vm.changePlataform}},[_vm._v(" Usar novo editor "),_c('span',{staticClass:"cut right"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }